'use client';

import { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Sidebar from '@/components/sidebar/Sidebar';

interface AnimatedSidebarProps {
  children?: ReactNode;
  isOpen?: boolean;
  onClose?: () => void;
}

export default function AnimatedSidebar({ children, isOpen = true, onClose }: AnimatedSidebarProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay for mobile */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black z-40 lg:hidden"
            onClick={onClose}
          />

          {/* Sidebar */}
          <div className="lg:sticky lg:top-16 lg:h-[calc(100vh-64px)] lg:w-64 lg:flex-shrink-0">
            <motion.aside
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              exit={{ x: '-100%' }}
              transition={{ type: 'spring', stiffness: 300, damping: 30 }}
              className="fixed top-0 left-0 z-50 w-64 h-full bg-white dark:bg-gray-900 border-r dark:border-gray-800 overflow-y-auto lg:relative lg:block lg:h-full"
            >
              <Sidebar>{children}</Sidebar>
            </motion.aside>
          </div>
        </>
      )}
    </AnimatePresence>
  );
}
